import React, { useEffect, useState } from "react";
import orderService from "../../db/order-service";
import "./OrderDetails.scss";

const OrderDetails = (props) => {
  const orderId = props.orderId;
  const [order, setOrder] = useState({});
  const [productsInOrder, setProductsInOrder] = useState([]);

  useEffect(() => {
    const fetchOrderDetails = async () => {
      try {
        // Use PouchDB order service instead of API call
        const orderData = await orderService.getOrderById(orderId);
        
        // Format order data
        setOrder({
          orderId: orderData._id,
          fname: orderData.customerName || "Customer",
          totalPrice: orderData.totalAmount,
          createdDate: new Date(orderData.date).toLocaleDateString(),
          address: orderData.shippingAddress
        });
        
        // Set products from order items
        if (orderData.items && Array.isArray(orderData.items)) {
          const products = orderData.items.map(item => ({
            productId: item.productId,
            name: item.name,
            quantity: item.quantity,
            totalPrice: item.price * item.quantity
          }));
          
          setProductsInOrder(products);
        }
      } catch (err) {
        console.log("Error fetching order details:", err);
      }
    };
    
    if (orderId) {
      fetchOrderDetails();
    }
  }, [orderId]);

  const handleBackClick = () => {
    props.onBackClick(); // Go back to the previous page
  };

  return (
    <div className="order-details-container">
      <div className="back-button-container">
        <button onClick={handleBackClick}>Back</button>
      </div>
      <div>
        <label>Order Id</label>
        <input type="text" value={orderId} disabled></input>
      </div>
      <div>
        <label>Customer Name</label>
        <input type="text" value={order.fname} disabled></input>
      </div>

      <div>
        <label>Total Cost</label>
        <input type="text" value={order.totalPrice} disabled></input>
      </div>

      <div>
        <label>Order Date</label>
        <input type="text" value={order.createdDate} disabled></input>
      </div>
      <div>
        <label>Address</label>
        <input type="text" value={order.address} disabled></input>
      </div>

      <div>
        <h1>Products In the Order</h1>
        <table>
          <thead>
            <tr>
              <th>Product Id</th>
              <th>Product Name</th>
              <th>Quantity</th>
              <th>Total Price</th>
            </tr>
          </thead>
          <tbody>
            {productsInOrder.map((product) => {
              return (
                <tr key={product.productId}>
                  <td>{product.productId}</td>
                  <td>{product.name}</td>
                  <td>{product.quantity}</td>
                  <td>{product.totalPrice}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OrderDetails;